module.exports = require("@makemydeal/dr-offer-redux");